module.exports = __webpack_public_path__ + "img/number_order.ad928f12.svg";